export function selectPermissions() {
    return (state) => state.permissionsPage.current;
}